import { useAnalyticsConsent } from '@configs/one-trust';
import { useAuth } from '@contexts/auth-provider';

/**
 * The single analytics tracking rule for the whole application, remotes included.
 *
 * Reactive to OneTrust consent changes, so callers re-evaluate on withdrawal
 * rather than reading consent once at first render.
 *
 * @returns `true` when allowed, `false` when denied, or `null` while consent is unknown
 */
export function useCanTrackAnalytics(): boolean | null {
  const { authData } = useAuth();
  const hasConsent = useAnalyticsConsent();

  // Internal users stay identified for operational reporting.
  return Boolean(authData?.isInternalUser) || hasConsent;
}
